import Dashboard from '../containers/Dashboard';
import LandingPage from '../containers/landingPage';
import Dokter from '../containers/MasterData/dokter';
import Pasien from '../containers/MasterData/pasien';
import UserManagement from '../containers/MasterData/userManagement';
import Screen404 from '../containers/screen404';
import Pembayaran from '../containers/pembayaran/pembayaran';
import DetailTagihan from '../containers/pembayaran/DetailTagihan';
import DetailTagihanNonReservasiFarmasi from '../containers/pembayaran/DetailTagihanNonReservasiFarmasi';
import AddPembayaran from '../containers/pembayaran/addPembayaran';
import AddTagihanResep from '../containers/pembayaran/addTagihanResep';
import PerubahanReservasi from '../containers/Transaksi/perubahanReservasi';
import Reservasi from '../containers/Transaksi/reservasi';
import DaftarReservasi from '../containers/Transaksi/daftarReservasi';
import Poliklinik from '../containers/MasterData/poliklinik';
import UserRole from '../containers/MasterData/userRole';
import JadwalDokter from '../containers/MasterData/jadwalDokter';
import JadwalPoliklinik from '../containers/MasterData/jadwalPoliklinik';
import JadwalFasilitas from '../containers/MasterData/jadwalFasilitas';
import MetodePembayaran from '../containers/MasterData/metodePembayaran';
import ListProvider from '../containers/MasterData/listProviderAsuransi';
import Farmasi from '../containers/MasterData/farmasi';
import Laboratorium from '../containers/MasterData/laboratorium';
import Ruangan from '../containers/MasterData/ruangan';
import Loket from '../containers/MasterData/loket';
import Fasilitas from '../containers/MasterData/fasilitas';
import Promo from '../containers/MasterData/promo';
import Ambulance from '../containers/MasterData/ambulance';
import RumahSakit from '../containers/MasterData/rumahSakit';
import TambahJadwal from '../containers/MasterData/tambahJadwal';
import PemanggilanAntrian from '../containers/Dokter/pemanggilanAntrian';
import PemanggilanFarmasi from '../containers/Farmasi/pemanggilanFarmasi';
import JadwalTransaksiDokter from '../containers/Transaksi/jadwalTransaksiDokter'
import JadwalTransaksiPoli from '../containers/Transaksi/jadwalTransaksiPoli'
import EditJadwalDokter from '../containers/Transaksi/editJadwalDokter';
import Akun from '../containers/MasterData/akun';
import PemanggilanRadiologi from '../containers/Radiology/pemanggilanRadiologi';
import PemanggilanCITOPOLIRadiologi from '../containers/Radiology/pemanggilanCITOPOLIRadiologi';
import PemanggilanHematologi from '../containers/Facility/pemanggilanHematologi';
import PemanggilanTHT from '../containers/Facility/pemanggilanTHT';
import PemanggilanJantung from '../containers/Facility/pemanggilanJantung';
import PemanggilanSGOT from '../containers/Facility/pemanggilanSGOT';
import ListPemanggilanDokter from '../containers/Dokter/listPemanggilanDokter';
import Spesialis from '../containers/MasterData/spesialis';
import Room from '../containers/MasterData/room';
import PemanggilanAsuransi from '../containers/Facility/pemanggilanAsuransi';
import PemanggilanBPJS from '../containers/Facility/pemanggilanBPJS';
import PemanggilanRegistrasi from '../containers/Facility/pemanggilanRegistrasi';
import PemanggilanKasir from '../containers/Facility/pemanggilanKasir';
import PemanggilanTransaksi from '../containers/Facility/pemanggilanTransaksi';
import PemanggilanObat from '../containers/Farmasi/pemanggilanObat';
import EditJadwal from '../containers/MasterData/editJadwal';
import DetailJadwalDokter from '../containers/MasterData/detailJadwalDokter';
import TambahJadwalPoliklinik from '../containers/MasterData/tambahJadwalPoliklinik';
import SubFasilitas from '../containers/MasterData/subFacilitas';
import DetailJadwalPoli from '../containers/MasterData/detailJadwalPoli';
import DetailAkun from '../containers/MasterData/detailAkun';
import FarmasiDalam from '../containers/Farmasi/farmasiDalam';
import KelolaLoket from '../containers/Farmasi/kelolaLoket';
import Screnning from '../containers/MasterData/screnning';
import AddScrenning from '../containers/MasterData/addScrenning';
import PengambilanHasil from '../containers/lab/pengambilanHasil';
import DetailScrenning from '../containers/MasterData/detailScrenning';
import PemanggilanLabVerifikasi from '../containers/lab/pemanggilanLabVerifikasi';
import SkrinningPasien from '../containers/Transaksi/skrinningPasien';
import DetailSkrinningPasien from '../containers/Transaksi/detailSkrinningPasien';
import DetailReservasi from '../containers/Transaksi/detailReservasi';
import CreateSkriningPasien from '../containers/Transaksi/createSkriningPasien';
import Parameter from '../containers/Setting/Parameter';
import SHSDokter from '../containers/Dokter/SHSDokter';
import QueueDisplay from '../containers/Setting/QueueDisplay';
import TambahJadwalDokter from '../containers/Transaksi/tambahJadwalDokter';
import Building from '../containers/MasterData/building';
import OpsiPemanggilanFarmasi from '../containers/pemanggilan/opsiPemanggilanFarmasi';
import OpsiPemanggilanLab from '../containers/pemanggilan/opsiPemanggilanLab';
import DetailPembayaran from '../containers/pembayaran/detailPembayaran';
import DetailJadwalFasilitas from '../containers/MasterData/detailJadwalFasilitas';
import TambahJadwalFasilitas from '../containers/MasterData/tambahJadwalFasilitas';
import PemanggilanNurseStation from '../containers/Facility/pemanggilanNurseStation';
import Kiosk from '../containers/Setting/kiosk';
import Laporan from '../containers/report/Laporan';
import RiwayatPembayaran from '../containers/pembayaran/riwayatPembayaran';
import OpsiPemanggilanRegistrasiUmum from '../containers/pemanggilan/opsiPemanggilanRegistrasi';
import OpsiPemanggilanRegistrasAsuransi from '../containers/pemanggilan/opsiPemanggilanAsuransi';
import OpsiPemanggilanRegistrasiBPJS from '../containers/pemanggilan/opsiPemanggilanBPJS';
import OpsiPemanggilanBerkasBPJS from '../containers/pemanggilan/opsiPemanggilanBerkasBPJS';
import OpsiPemanggilanRadiologi from '../containers/pemanggilan/opsiPemanggilanRadiologi';
import OpsiPemanggilanKasir from '../containers/pemanggilan/opsiPemanggilanKasir';
import SHSRegisUmum from '../containers/Facility/SHSRegisUmum';
import SHSRegisBPJS from '../containers/Facility/SHSRegisBPJS';
import SHSRegisAsuransi from '../containers/Facility/SHSRegisAsuransi';
import SHSLab from '../containers/Facility/SHSLab';
import SHSRadiologi from '../containers/Facility/SHSRadiologi';
import OpsiPemanggilanTransaksi from '../containers/pemanggilan/opsiPemanggilanTransaksi';
import SHSBerkasBPJS from '../containers/Facility/SHSBerkasBPJS';
import SHSTransaksi from '../containers/Facility/SHSTransksi';
import AddSchedulePoli from '../containers/Transaksi/addSchedulePoli';
import FAQ from '../containers/Setting/FAQ';
import TableFAQ from '../containers/Setting/tableFAQ';
import TableTNC from '../containers/Setting/tableTNC';
import KategoriFAQ from '../containers/MasterData/KategoriFAQ';
import EditFAQ from '../containers/Setting/editFAQ';
import HistoryReservasi from '../containers/Transaksi/historyReservasi';
import DetailHistoryReservasi from '../containers/Transaksi/detailHistoryReservasi';
import HistoryRegistrasiUmum from '../containers/Facility/HistoryRegistrasiUmum';
import HistoryRegistrasiBPJS from '../containers/Facility/HistoryRegistrasiBPJS';
import HistoryRegistrasiAsuransi from '../containers/Facility/HistoryRegistrasiAsuransi';
import HistoryPenyerahanBPJS from '../containers/Facility/HistoryPenyerahanBPJS';
import HistoryFarmasi from '../containers/Facility/HistoryFarmasi';
import HistoryLab from '../containers/Facility/HistoryLab';
import HistoryRadiologi from '../containers/Facility/HistoryRadiologi';
import HistoryDokter from '../containers/Dokter/HistoryDokter';
import SHSKasir from '../containers/Facility/SHSKasir';
import PemanggilanKasirVerifikasi from '../containers/Kasir/pemanggilanKasirVerifikasi';
import HistoryKasir from '../containers/Facility/HistoryKasir';
import TNC from '../containers/Setting/TNC';
import HistoryTransaksi from '../containers/Facility/HistoryTransaksi';
import TablePP from '../containers/Setting/tablePP';
import PrivacyPolicy from '../containers/Setting/PrivacyPolicy';
import EditTNC from '../containers/Setting/editTNC';
import EditPrivacyPolicy from '../containers/Setting/editPrivacyPolicy';
import DetailRiwayatTransaksi from '../containers/Transaksi/DetailRiwayatTransaksi';
import HistoryPembayaran from '../containers/Facility/HistoryPembayaran';
import OpsiPemanggilanFarmasiDalam from '../containers/pemanggilan/opsiPemanggilanFarmasiDalam';
import HistoryFarmasiPanggilan from '../containers/Facility/HistoryFarmasiPanggilan';
import HistorySkrining from '../containers/Transaksi/historySkrining';
import DetailHistorySkriningPasien from '../containers/Transaksi/detailHistorySkriningPasien';
import OpsiPemanggilanAllRegis from '../containers/pemanggilan/opsiPemanggilanAllRegis';
import SHSAllRegis from '../containers/Facility/SHSAllRegis';
import HistoryAllRegis from '../containers/Facility/HistoryAllRegis';
import Promosi from '../containers/Setting/Promosi';
import TablePromosi from '../containers/Setting/tablePromosi';
import EditPromosi from '../containers/Setting/editPromosi';
import RunningText from '../containers/Setting/RunningText';
import TableMediaDisplay from '../containers/Setting/tableMediaDisplay';
import AddMediaDisplay from '../containers/Setting/AddMediaDisplay';
import EditMediaDisplay from '../containers/Setting/EditMediaDisplay';
import LeadTimeFasilitas from '../containers/report/LeadTimeFasilitas';
import LeadTimeDokter from '../containers/report/LeadTimeDokter';
import DokterCuti from '../containers/MasterData/dokterCuti';
import MonitorResep from '../containers/Farmasi/monitorResep';
import DetailResep from '../containers/Farmasi/detailResep';
import NatinalHoliday from '../containers/Setting/NatinalHoliday';
import Emergency from '../containers/Emergency/emergency';
import HistoryEmergency from '../containers/Emergency/historyEmergency';
import DetailEmergency from '../containers/Emergency/detailEmergency';
import AddEmergency from '../containers/Emergency/AddEmergency';
import DetailHistoryEmergency from '../containers/Emergency/detailHistoryEmergency';
import PetugasEmergency from '../containers/Emergency/petugasEmergency';
import CatatanDokter from '../containers/Dokter/CatatanDokter';
import MasterDokter from '../containers/telemedicine/masterDokter';
import MasterJadwal from '../containers/telemedicine/masterJadwal';
import MasterHarga from '../containers/telemedicine/masterHarga';
import MasterSpesialis from '../containers/telemedicine/masterSpesialis';
import MonitoringRuangan from '../containers/report/MonitoringRuangan';
import monitoringBiaya from '../containers/telemedicine/monitoringBiaya';
import MonitoringOrder from '../containers/telemedicine/monitoringOrder';
import MonitoringReservasi from '../containers/telemedicine/monitoringReservasi';
import UploadAppointment from '../containers/upload/UploadAppointment';
import MasterJadwalTelemedicine from '../containers/telemedicine/masterJadwalTelemedicine';
import JadwalTelemedicine from '../containers/telemedicine/jadwalTelemedicine';
import LeadTimePharmacy from '../containers/report/LeadTimePharmacy';
import MasukanSaran from '../containers/menuLain/masukanSaran';
import Ulasan from '../containers/menuLain/ulasan';
import MonitoringTransaksi from '../containers/report/MonitoringTransaksi';
import riwayatReservasi from '../containers/Transaksi/riwayatReservasi';
import DraftScheduleDokter from '../containers/Transaksi/DraftScheduleDokter';
import DownloadScheduleDokter from '../containers/Transaksi/DownloadScheduleDokter';
import ReportAppointment from '../containers/report/ReportAppointment';
import GeneralConcenst from '../containers/report/GeneralConcenst';
import SHSCampuran from '../containers/Facility/SHSCampuran';
import OpsiPemanggilanCampuran from '../containers/pemanggilan/opsiPemanggilanCampuran';
import HistoryCampuran from '../containers/Facility/HistoryCampuran';
import DraftingJadwal from '../containers/Transaksi/DraftingJadwal';
import MonitoringHasilLab from '../containers/lab/MonitoringHasilLab';
import HasilLab from '../containers/lab/HasilLab';
import RiwayatHasilLab from '../containers/lab/RiwayatHasilLab';
import MonitoringHasilRadiologi from '../containers/Radiology/MonitoringHasilRadiologi';
import HasilRadiologi from '../containers/Radiology/HasilRadiologi';
import RiwayatHasilRadiologi from '../containers/Radiology/RiwayatHasilRadiologi';
import Asuransi from '../containers/MasterData/Insurance';
import DetailTagihanNonReservasiLab from '../containers/pembayaran/DetailTagihanNonReservasiLab'
import DetailTagihanNonReservasiRadiologi from '../containers/pembayaran/DetailTagihanNonReservasiRadiologi'
import PIPPage from '../containers/components/pip/pip_page';
import TabScreen from '../containers/Test/TabScreen';
import MainPanggilanAntrian from '../containers/Dokter/Antrian/main_panggil_antrian_screen';

const routes = [
    {
        path: "/dashboard",
        main: Dashboard
    },
    {
        path: "/landing-page",
        main: LandingPage
    },
    {
        path: "/masterdata/pasien",
        main: Pasien
    },
    {
        path: "/masterdata/poli",
        main: Poliklinik
    },
    {
        path: "/setting/user-management",
        main: UserManagement
    },
    {
        path: "/setting/user-role",
        main: UserRole
    },
    {
        path: "/masterdata/akun",
        main: Akun
    },
    {
        path: "/masterdata/detail-akun",
        main: DetailAkun
    },
    {
        path: "/masterdata/dokter",
        main: Dokter
    },
    {
        path: "/schedule/Jadwal-dokter",
        main: JadwalDokter
    },
    {
        path: "/masterdata/detail-Jadwal-dokter",
        main: DetailJadwalDokter
    },
    {
        path: "/masterdata/tambah-jadwal",
        main: TambahJadwal,
    },
    {
        path: "/masterdata/edit-jadwal",
        main: EditJadwal,
    },
    {
        path: "/schedule/jadwal-poli",
        main: JadwalPoliklinik
    },
    {
        path: "/schedule/detail-jadwal-poli",
        main: DetailJadwalPoli
    },
    {
        path: "/schedule/detail-jadwal-fasilitas",
        main: DetailJadwalFasilitas
    },
    {
        path: "/masterdata/tambah-jadwal-poliklinik",
        main: TambahJadwalPoliklinik
    },
    {
        path: "/masterdata/tambah-jadwal-fasilitas",
        main: TambahJadwalFasilitas
    },
    {
        path: "/schedule/jadwal-dokter-cuti",
        main: DokterCuti
    },
    {
        path: "/masterdata/metode-pembayaran",
        main: MetodePembayaran
    },
    {
        path: "/masterdata/list-provider-asuransi",
        main: ListProvider
    },
    {
        path: "/report/monitor",
        main: Laporan
    },
    {
        path: "/masterdata/farmasi",
        main: Farmasi
    },
    {
        path: "/masterdata/laboratorium",
        main: Laboratorium
    },
    {
        path: "/masterdata/ruangan",
        main: Ruangan
    },
    {
        path: "/masterdata/spesialis",
        main: Spesialis
    },
    {
        path: "/masterdata/loket",
        main: Loket
        // main: MaxWidthDialog
        // main: PIPPage
    },
    {
        path: "/masterdata/fasilitas",
        main: Fasilitas
    },
    {
        path: "/masterdata/sub-fasilitas",
        main: SubFasilitas
    },
    {
        path: "/schedule/jadwal-fasilitas",
        main: JadwalFasilitas
    },
    {
        path: "/masterdata/promo",
        main: Promo
    },
    {
        path: "/masterdata/ambulance",
        main: Ambulance
    },
    {
        path: "/masterdata/building",
        main: Building
    },
    {
        path: "/masterdata/room",
        main: Room
    },
    {
        path: "/masterdata/skrining",
        main: Screnning
    },
    {
        path: "/masterdata/detail-skrining",
        main: DetailScrenning
    },
    {
        path: "/masterdata/tambah-skrining",
        main: AddScrenning
    },
    {
        path: "/masterdata/rumah-sakit",
        main: RumahSakit
    },
    {
        path: "/masterdata/kategori-faq",
        main: KategoriFAQ
    },
    {
        path: "/dokter/reservasi-dokter",
        main: Reservasi
    },
    {
        path: "/registrasi-umum/riwayat",
        main: HistoryRegistrasiUmum
    },
    {
        path: "/registrasi-bpjs/riwayat",
        main: HistoryPenyerahanBPJS
    },
    {
        path: "/registrasi-asuransi/riwayat",
        main: HistoryRegistrasiAsuransi
    },
    {
        path: "/penyerahan-bpjs/riwayat",
        main: HistoryRegistrasiBPJS
    },
    {
        path: "/farmasi/riwayat",
        main: HistoryFarmasi
    },
    {
        path: "/farmasi/riwayat-panggilan",
        main: HistoryFarmasiPanggilan
    },
    {
        path: "/lab/riwayat",
        main: HistoryLab
    },
    {
        path: "/radiologi/riwayat",
        main: HistoryRadiologi
    },
    {
        path: "/radiologi/monitoring-hasil",
        main: MonitoringHasilRadiologi
    },
    {
        path: "/radiologi/hasil-radiologi",
        main: HasilRadiologi
    },
    {
        path: "/radiologi/monitoring-riwayat-hasil",
        main: RiwayatHasilRadiologi
    },
    {
        path: "/kasir/riwayat",
        main: HistoryKasir
    },
    {
        path: "/dokter/riwayat-panggilan",
        main: HistoryDokter
    },
    {
        path: "/registrasi-umum/start-hold-stop",
        main: SHSRegisUmum
    },
    {
        path: "/registrasi-bpjs/start-hold-stop",
        main: SHSRegisBPJS
    },
    {
        path: "/penyerahan-bpjs/start-hold-stop",
        main: SHSBerkasBPJS
    },
    {
        path: "/registrasi-asuransi/start-hold-stop",
        main: SHSRegisAsuransi
    },
    {
        path: "/transaksi/start-hold-stop",
        main: SHSTransaksi
    },
    {
        path: "/lab/start-hold-stop",
        main: SHSLab
    },
    {
        path: "/kasir/start-hold-stop",
        main: SHSKasir
    },
    {
        path: "/radiologi/start-hold-stop",
        main: SHSRadiologi
    },
    {
        path: "/dokter/start-hold-stop",
        main: SHSDokter
    },
    {
        path: "/dokter/detail-reservasi-dokter",
        main: DetailReservasi
    },
    // {
    //     path: "/dokter/history-reservasi",
    //     main: HistoryReservasi
    // },
    {
        path: "/dokter/history-reservasi",
        main: riwayatReservasi
    },
    {
        path: "/dokter/detail-histori-reservasi",
        main: DetailHistoryReservasi
    },
    {
        path: "/schedule/perubahan-jadwal-dokter",
        main: PerubahanReservasi
    },
    {
        path: "/dokter/daftar-reservasi",
        main: DaftarReservasi
    },
    {
        path: "/pembayaran/monitoring",
        main: Pembayaran
    },
    {
        path: "/pembayaran/detail-tagihan",
        main: DetailTagihan
    },
    {
        path: "/pembayaran/detail-tagihan-non-reservasi-farmasi",
        main: DetailTagihanNonReservasiFarmasi
    },
    {
        path: "/pembayaran/detail-tagihan-non-reservasi-lab",
        main: DetailTagihanNonReservasiLab
    },
    {
        path: "/pembayaran/detail-tagihan-non-reservasi-radiologi",
        main: DetailTagihanNonReservasiRadiologi
    },
    {
        path: "/transaksi/add-pembayaran",
        main: AddPembayaran
    },
    {
        path: "/transaksi/add-tagihan-resep",
        main: AddTagihanResep
    },
    {
        path: "/pembayaran/detail-monitoring",
        main: DetailPembayaran
    },
    {
        path: "/transaksi/detail-riwayat",
        main: DetailRiwayatTransaksi
    },
    {
        path: "/transaksi/riwayat",
        main: HistoryTransaksi
    },
    {
        path: "/pembayaran/riwayat-pembayaran",
        main: HistoryPembayaran
    },
    {
        path: "/skrining/pemanggilan-skrining",
        main: SkrinningPasien
    },
    {
        path: "/skrining/riwayat-skrining",
        main: HistorySkrining
    },
    {
        path: "/transaksi/detail-riwayat-skrining-pasien",
        main: DetailHistorySkriningPasien
    },
    {
        path: "/transaksi/detail-skrining-pasien",
        main: DetailSkrinningPasien
    },
    {
        path: "/transaksi/pemanggilan",
        main: OpsiPemanggilanTransaksi
    },
    {
        path: "/transaksi/pemanggilan-transaksi",
        main: PemanggilanRegistrasi
    },
    {
        path: "/registrasi/pemanggilan-registrasi",
        main: OpsiPemanggilanAllRegis
    },
    {
        path: "/registrasi/pemanggilan-all-registrasi",
        main: PemanggilanRegistrasi
    },
    {
        path: "/registrasi/start-hold-stop",
        main: SHSAllRegis
    },
    {
        path: "/registrasi/riwayat",
        main: HistoryAllRegis
    },
    {
        path: "/transaksi-campuran/panggilan-antrian",
        main: OpsiPemanggilanCampuran
    },
    {
        path: "/transaksi-campuran/kelola-sesi",
        main: SHSCampuran
    },
    {
        path: "/transaksi-campuran/riwayat-panggilan-antrian",
        main: HistoryCampuran
    },
    {
        path: "/skrining/create-skrining-pasien",
        main: CreateSkriningPasien
    },
    {
        path: "/dokter/pemanggilan-dokter",
        main: ListPemanggilanDokter
    }, 
    {
        path: "/dokter/detail-pemanggilan",
        // main: PemanggilanAntrian
        main: MainPanggilanAntrian
    },
    {
        path: "/pemanggilan-facility/lab-hematology",
        main: PemanggilanHematologi
    },
    {
        path: "/pemanggilan-facility/lab-tht",
        main: PemanggilanTHT
    },
    {
        path: "/pemanggilan-facility/lab-jantung",
        main: PemanggilanJantung
    },
    {
        path: "/pemanggilan-facility/lab-sgot",
        main: PemanggilanSGOT
    },
    {
        path: "/registrasi-asuransi/pemanggilan-registrasi-asuransi",
        main: OpsiPemanggilanRegistrasAsuransi
    },
    {
        path: "/registrasi-asuransi/pemanggilan-registrasi",
        main: PemanggilanRegistrasi
    },
    {
        path: "/registrasi-bpjs/pemanggilan-registrasi-bpjs",
        main: OpsiPemanggilanRegistrasiBPJS
    },
    {
        path: "/penyerahan-bpjs/pemanggilan-penyerahan-bpjs",
        main: OpsiPemanggilanBerkasBPJS
    },
    {
        path: "/registrasi-bpjs/pemanggilan-registrasi",
        main: PemanggilanRegistrasi
        // main: TabScreen
    },
    {
        path: "/registrasi-umum/pemanggilan-registrasi-umum",
        main: OpsiPemanggilanRegistrasiUmum
    },
    {
        path: "/registrasi-umum/pemanggilan-registrasi",
        main: PemanggilanRegistrasi
    },
    {
        path: "/nurse-station/pemanggilan-nurse-station",
        main: PemanggilanNurseStation
    },
    {
        path: "/transaksi/kasir",
        main: PemanggilanKasir
    },
    // {
    //     path: "/transaksi/pemanggilan",
    //     main: PemanggilanTransaksi
    // },
    {
        path: "/lab/pemanggilan-verifikasi",
        main: PemanggilanLabVerifikasi
    },
    {
        path: "/lab/pemanggilan",
        main: OpsiPemanggilanLab
    },
    {
        path: '/lab/monitoring-hasil',
        main: MonitoringHasilLab
    },
    {
        path: "/kasir/pemanggilan",
        main: OpsiPemanggilanKasir
    },
    {
        path: "/kasir/pemanggilan-verifikasi",
        main: PemanggilanKasirVerifikasi
    },
    {
        path: "/radiologi/pemanggilan-radiologi-verifikasi",
        main: OpsiPemanggilanRadiologi
    },
    {
        path: "/radiologi/pemanggilan-radiologi",
        main: PemanggilanLabVerifikasi
    },
    // {
    //     path: "/radiologi/pemanggilan-radiologi-citopoli",
    //     main: PemanggilanCITOPOLIRadiologi
    // },
    {
        path: "/farmasi/pemanggilan-farmasi",
        main: OpsiPemanggilanFarmasi    
    },
    {
        path: "/farmasi/pemanggilan",
        main: PemanggilanFarmasi    
    },
    {
        path: "/farmasi/pemanggilan-obat",
        main: PemanggilanObat    
    },
    {
        path: "/farmasi/farmasi-dalam",
        main: OpsiPemanggilanFarmasiDalam    
    },
    {
        path: "/farmasi/farmasi-dalam-list",
        main: FarmasiDalam    
    },
    {
        path: "/farmasi/kelola-loket",
        main: KelolaLoket    
    },
    {
        path: "/farmasi/resep",
        main: MonitorResep    
    },
    {
        path: "/farmasi/detail-resep",
        main: DetailResep    
    },
    {
        path: "/schedule/jadwal-transaksi-dokter",
        main: JadwalTransaksiDokter
    },
    {
        path: "/schedule/edit-jadwal-dokter",
        main: EditJadwalDokter
    },
    {
        path: "/schedule/tambah-jadwal-dokter",
        main: TambahJadwalDokter
    },
    {
        path: "/dokter/catatan",
        main: CatatanDokter
    },
    {
        path: "/schedule/jadwal-poliklinik",
        main: JadwalTransaksiPoli
    },
    {
        path: "/schedule/tambah-jadwal-poliklinik",
        main: AddSchedulePoli
    },
    {
        path: "/lab/pengambilan-hasil",
        main: PengambilanHasil
    },
    {
        path: "/lab/hasil-lab",
        main: HasilLab
    },
    {
        path: "/lab/monitoring-riwayat-hasil",
        main: RiwayatHasilLab
    },
    {
        path: "/setting/parameter",
        main: Parameter
    },
    {
        path: "/setting/queue-display",
        main: QueueDisplay
    },
    {
        path: "/setting/kiosk",
        main: Kiosk
    },
    {
        path: "/setting/faq",
        main: TableFAQ
    },
    {
        path: "/setting/tambah-faq",
        main: FAQ
    },
    {
        path: "/setting/tnc",
        main: TableTNC
    },
    {
        path: "/setting/tambah-tnc",
        main: TNC
    },
    {
        path: "/setting/privacy-policy",
        main: TablePP
    },
    {
        path: "/setting/tambah-pp",
        main: PrivacyPolicy
    },
    {
        path: "/setting/edit-faq",
        main: EditFAQ
    },
    {
        path: "/setting/edit-tnc",
        main: EditTNC
    },
    {
        path: "/setting/edit-pp",
        main: EditPrivacyPolicy
    },
    {
        path: "/setting/promosi",
        main: TablePromosi
    },
    {
        path: "/setting/running-text",
        main: RunningText
    },
    {
        path: "/setting/tv-media-display",
        main: TableMediaDisplay
    },
    {
        path: "/setting/tambah-promosi",
        main: Promosi
    },
    {
        path: "/setting/edit-promosi",
        main: EditPromosi
    },
    {
        path: "/setting/tambah-media",
        main: AddMediaDisplay
    },
    {
        path: "/setting/edit-media",
        main: EditMediaDisplay
    },
    {
        path: "/setting/libur-nasional",
        main: NatinalHoliday
    },
    {
        path: "/report/lead-time-process-facility",
        main: LeadTimeFasilitas
    },
    {
        path: "/report/lead-time-process-pharmacy",
        main: LeadTimePharmacy
    },
    {
        path: "/report/lead-time-process-doctor",
        main: LeadTimeDokter
    },
    {
        path: "/report/monitor-ruangan",
        main: MonitoringRuangan
    },
    {
        path: "/report/monitoring-transaksi",
        main: MonitoringTransaksi
    },
    {
        path: "/report/appointment-by-doctor-schedule",
        main: ReportAppointment
    },
    {
        path: "/report/monitoring-general-consent",
        main: GeneralConcenst
    },
    {
        path: "/emergency/active-order",
        main: Emergency
    },
    {
        path: "/emergency/riwayat",
        main: HistoryEmergency
    },
    {
        path: "/emergency/detail-emergency",
        main: DetailEmergency
    },
    {
        path: "/emergency/add-emergency",
        main: AddEmergency
    },
    {
        path: "/emergency/detail-history-emergency",
        main: DetailHistoryEmergency
    },
    {
        path: "/emergency/master-emergency-officer",
        main: PetugasEmergency
    },
    {
        path: "/telemedicine/master-doctor-telemedicine",
        main: MasterDokter
    },
    {
        path: "/telemedicine/master-jadwal-telemedicine",
        main: MasterJadwalTelemedicine
    },
    {
        path: "/telemedicine/jadwal-telemedicine",
        main: JadwalTelemedicine
    },
    {
        path: "/telemedicine/master-harga-telemedicine",
        main: MasterHarga
    },
    {
        path: "/telemedicine/master-specialty-telemedicine",
        main: MasterSpesialis
    },
    {
        path: "/telemedicine/monitoring-biaya-telemedicine",
        main: monitoringBiaya
    },
    {
        path: "/telemedicine/monitoring-transaksi-order-telemedicine",
        main: MonitoringOrder
    },
    {
        path: "/telemedicine/monitoring-reservasi-telemedicine",
        main: MonitoringReservasi
    },
    {
        path: "/upload/appointment",
        main: UploadAppointment
    },
    {
        path: "/lain-lain/masukan",
        main: MasukanSaran
    },
    {
        path: "/lain-lain/ulasan",
        main: Ulasan
    },
    {
        path: "/schedule/draft-master-jadwal-dokter",
        main: DraftScheduleDokter
    },
    {
        path: "/schedule/draft-master-jadwal",
        main: DraftingJadwal
    },
    {
        path: "/schedule/download-jadwal-dokter",
        main: DownloadScheduleDokter
    },
    {
        path: "/masterdata/asuransi",
        main: Asuransi
    },
    {
        path: "*",
        main: Screen404
    }
];

export default routes;

//coba aja